import React, { useEffect, useState } from 'react';

import { Spinner } from '../../../components/Spinner/spinner';
import PrimusHandler from '../../../api/primusHandler';
import { AppContainer, AppWrapper } from './styles';

export default function PaymentLandingPage(props) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (window.location.pathname.search('/checkout') < 0) {
      let interval = setInterval(() => {
        if (PrimusHandler.isWebsocketConnected()) {
          clearInterval(interval);
          setLoading(false);
          props.history.push('/plans');
        }
      }, 200);
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <AppContainer>
      <AppWrapper>
        {loading && <Spinner title="Loading..." text="Do not refresh / reload the page until processing is done..." />}
      </AppWrapper>
    </AppContainer>
  );
}
